import type { OrderDetailsExtended } from 'app/src/model'
import { apiBaseUrl } from 'app/src/msw/shopping/staticapi/apiBaseUrl'
import { getDetailPageUrl } from 'app/src/msw/shopping/utils/getDetailPageUrl'
import type { shoppingApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const activateProduct = http.post<object, shoppingApi.ActivateRequest, shoppingApi.ActivateResult>(
  apiBaseUrl + '/activate',
  async ({ request }) => {
    const bodyReq = await request.json()

    console.log('activateProduct bodyReq', bodyReq)

    const activeMembership = JSON.parse(sessionStorage.getItem('selectedCampaign') || '{}')
    console.log('activeMembership', activeMembership)

    const membership = await (await fetch('./data/membership/membership.json')).json()

    console.log('activateProduct membership', membership)

    const orderId = bodyReq.product.typology

    const order: OrderDetailsExtended = {
      ...bodyReq,
      orderId,
      status: 'draft',
      isCancelable: true,
      userInfo: {
        userId: membership?.userId || 'bartolomeo.ovilipo@posteitaliane.it',
        firstName: membership?.userFirstName || 'Bartolomeo',
        lastName: membership?.userLastName || 'Ovilio',
        email: membership?.userEmail || 'bartolomeo.ovilipo@posteitaliane.it',
        fiscalCode: membership?.userFiscalCode || 'BRTLVO80A01H501C',
        membershipId: membership?.membershipId || 'fgh',
      },
      priceDetails: {
        grossPrice: bodyReq.variant.priceDetails?.finalGrossPrice || 10,
        netPrice: bodyReq.variant.priceDetails?.facePrice || 10,
        taxPercentage: bodyReq.variant.priceDetails?.taxPercentage || 10,
        taxAmount: 0,
        taxClass: bodyReq.variant.priceDetails?.taxClass,
        discountType: bodyReq.variant.priceDetails?.discountType,
        discountValue: bodyReq.variant.priceDetails?.discountValue,
      },
      orderDate: new Date().toISOString(),
      detailPageUrl: getDetailPageUrl(
        bodyReq.product.typology,
        orderId,
        bodyReq.product.typology === 'moneyTransfer' ? bodyReq.product.externalId : undefined,
      ),
      beneficiaries: bodyReq.beneficiaries,
      ...(bodyReq.product.typology === 'goodAndService' ? { externalPageUrl: `#/demoExternalOrder/${orderId}` } : {}),
      ...(bodyReq.product.typology === 'discount'
        ? { purchaseDetails: { typology: 'discount', purchaseDate: new Date().toISOString(), purchaseDescription: '' } }
        : {}),
    }

    return HttpResponse.json({
      method: 'GET',
      url: order.product.typology === 'goodAndService' ? order.externalPageUrl! : order.detailPageUrl,
      target: order.product.typology === 'goodAndService' ? '_blank' : '_self',
    })
  },
)
